import { render } from "./PAY010.vue?vue&type=template&id=6c572b13"
import script from "./PAY010.vue?vue&type=script&lang=ts"
export * from "./PAY010.vue?vue&type=script&lang=ts"
script.render = render

export default script